<!--
 * @Description: 嘉宾
 * @Author: 山淑兰
 * @Date: 2020-04-30 13:07:46
 * @LastEditTime: 2020-07-16 22:34:28
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="schedule" v-loading="isLoading">
		<div class="schedule_container">
			<!-- <div class="position" v-if="navShow">
				您的位置：<a :href="homeUrl">首页</a> > <a @click="goSchedules">专家风采</a>
			</div> -->
			<div class="filter">
				<div class="filter-label" style="line-height: 40px;" :style="{width:enShow?'130px':''}">
					{{enShow?'Query experts':'查询嘉宾'}}：
				</div>
				<div class="filter-wrap">
					<div class="search">
						<el-input :placeholder="searchText" v-model="searchWord"> </el-input>
						<el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
					</div>
				</div>
			</div>
			<div class="filter">
				<div class="filter-label" :style="{width:enShow?'130px':''}">
					{{enShow?'Select Date':'选择日期'}}：
				</div>
				<div class="filter-wrap">
					<ul class="meetingDate" v-if="dateDatas.length">
						<li v-for="(item, index) in dateDatas" :key="index" :class="{ selected: dateIndex === index }"
							@click="handleMeetingDate(index, item)">
							{{ item.name }}
						</li>
					</ul>
				</div>
			</div>
			<div class="schedule_table">
				<template>
					<div class="table_con">
						<div class="guest-con">
						    <div class="guestlist" v-for="(item,index) in pinYinList" :key="index" :ref="`pinyin${index}`">
								<template>
									<div class="expert-nav" :id="'guest-'+ index" v-if="expertList[item].length>0">
										{{item}}
									</div>
									<div class="guest-list" v-for="(items,indexs) in expertList[item]" :key="indexs" @click="handleExname(items.exid)">
										<div class="guest-photo">
											<img :src="items.photo || this.defaultHeadImg" alt />
										</div>
										<div class="guest-info">
											<div class="guest-cname" v-html="nToBr(items.cname)"></div>
											<div class="guest-cncompany" v-html="nToBr(items.cncompany)"></div>
											<div class="guest-cnintroduction">
												{{items.cnintroduction}}
												<span>{{enShow?'More':'查看详情'}}</span>
											</div>
										</div>
									</div>
								</template>
						    </div>
						    <div class="guset-nav" :class="fixed?'fixed':''">
						        <div class="letter-t" v-for="(item,index) in pinYinList" :key="index" :class="activeBtn==index?'weight':''" @click="goGuest('#guest-'+index,index)">
						            {{item}}
						        </div>
						    </div>
						</div>
						<!-- 嘉宾弹框 -->
						<div>
							<el-dialog :visible.sync="showExList" width="50%" center :close-on-click-modal="false">
								<template>
									<!-- 头像部分 -->
									<div class="details-head">
										<div class="guest-headimg" @click="viewPhoto()">
											<img :src="exPhoto || defaultHeadImg" alt />
										</div>
										<template>
											<div class="guest-intro">
												<div class="guest-name">
													<p v-html="nToBr(excnname)"></p>
													<p v-if="enShow" v-html="nToBr(enname)"></p>
												</div>
												<div class="host">
													<p v-html="nToBr(cncompany)"></p>
													<p v-if="enShow" v-html="nToBr(encompany)"></p>
												</div>
											</div>
										</template>
										<!-- <div class="uploadFile">
                      <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :limit="1"
                        :show-file-list="false"
                        :on-exceed="handleExceed"
                      >
                        <el-button size="small" type="primary">上传课件</el-button>
                      </el-upload>
                    </div> -->
									</div>
									<el-tabs v-model="activeName" @tab-click="handleClick">
										<el-tab-pane :label="enShow?'Profile':'嘉宾简介'" name="0" v-if="introShow">
											<div class="guestIntroduction">
												<p v-if="cnintroduction" v-html="cnintroduction"></p>
												<p v-if="enintroduction&&enShow" v-html="enintroduction"></p>
											</div>
										</el-tab-pane>
										<el-tab-pane :label="enShow?'Task':'嘉宾任务'" name="1" v-if="isshowprogram==0">
											<template v-if="exDatas.length">
												<div class="ex_details">
													<div class="details-main" v-for="(items, indexs) in exDatas"
														:key="indexs">
														<div class="details-main-head">
															<div class="details-main-head-date">
																<i class=" el-icon-date"></i>
																<span>{{ items[0].proDate }}</span>
															</div>
															<div class="details-list-num">{{ items[0].ProgramCount }}
															</div>
														</div>

														<div class="details-main-con" v-for="(it, id) in items"
															:key="id">
															<div class="details-texts">
																<i class="el-icon-tickets"></i>
																<div class="details-text">
																	<p v-html="nToBr(it.topic)"></p>
																	<p v-if="enShow" v-html="nToBr(it.entopic)"></p>
																</div>
															</div>
															<div class="details-texts">
																<i class="el-icon-time"></i>
																<span v-if="it.startTime">
																	{{ it.startTime }}-{{ it.endTime }}
																</span>
															</div>
															<div class="details-texts">
																<i class="el-icon-location-outline"></i>
																<div class="details-text">
																	<p>
																		{{ it.roomTitle }} {{ it.roomName }}
																	</p>
																	<p v-if="enShow">
																		{{ it.roomEnTitle }} {{ it.roomEnTitle }}
																	</p>
																</div>
															</div>
															<div class="details-texts">
																<i class="el-icon-s-custom"></i>
																<div class="details-text">
																	<p>
												  				{{ it.roleName }}
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</el-tab-pane>
										
									</el-tabs>
								</template>
							</el-dialog>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from "vue-property-decorator";
	import {
		IMeetingInfo,
		current
	} from "@/contants/current.ts";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode,
	} from "element-china-area-data";

	export default {
		data() {
			return {
				current: {},
				m: '',
				dateIndex: 0, //选中的日期的下标
				roomIndex: 0, //选中的会场的下标
				dateid: 0, //选中的日期id
				roomid: 0, //选中的会场id
				scheduleDatas: [], //日程表总数据
				Datas: [], //日程表总数据
				dateDatas: [], //日期数据
				pinYinList: [],
				expertList: [],
				searchWord: '', //搜索的内容
				searchW: '', //搜索的内容
				searchVal: '',
				searchDatas: [],
				issearch: false,
				isLoading: false,
				showExList: false, //是否显示嘉宾弹框
				exDatas: [],
				activeName: "0",
				defaultHeadImg: require("@/assets/images/defaultHeadImg.png"),
				exPhoto: '', //嘉宾头像
				cnintroduction: '', //嘉宾介绍
				excnname: '', //嘉宾姓名
				cncompany: '', //嘉宾公司
				enname: '',
				encompany: '',
				enintroduction: '',
				is_fixed: false, //是否吸顶
				colWidth: 0,
				offsetTop: 0,
				isFixed: false,
				isFun: true,
				fileList: [{
						name: "food.jpeg",
						url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
					},
					{
						name: "food2.jpeg",
						url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
					},
				],
				navShow: true,
				homeUrl: '',
				enShow: true,
				introShow: true,
				searchText: '请输入内容',
				fixed: false,
				activeBtn: -1,
				isshowprogram: '',
			}
		},
		created() {
			this.current = new current();
			let _isMobile = this.current.is_Mobile();

			if (_isMobile) {
				let _params = window.location.href.split("?")[1];
				window.location.href = `https://mp.weiqihd.com/mpweb/#/guest/place?${_params}`;
			}

			let {
				m
			} = this.$route.query;
			this.m = String(m);
			let parames = {
				m: this.m,
			};
			if (this.$route.query) {
			    this.dateid = this.$route.query.dateid
			    this.InitMeetingInfo()
			}
			this.fixed = false
			document.addEventListener('scroll', this.handleScroll, true)
			//this.GetAPIProgram(parames);
		},
		beforeDestroy () {
		    document.removeEventListener('scroll', this.handleScroll, true);
		},
		mounted() {
			//对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
			window.addEventListener("scroll", this.initHeight);
		},
		methods: {
			handleScroll(){
				//var a = document.getElementsByClassName('guest-con')[0].offsetHeight;
				let that = this
				// let i = 1
				// console.log(that.$refs[`pinyin${i}`][0].getBoundingClientRect().top)
				this.$nextTick(() => {    
					for( let i in that.pinYinList ){
						let pinyinHeight = that.$refs[`pinyin${i}`][0].getBoundingClientRect().top
						if( pinyinHeight <= 20 ){
							that.activeBtn = i
						}
					}
				})
				
				if( window.pageYOffset >= 206 ){
					this.fixed = true
				}else{
					this.fixed = false
					that.activeBtn = -1
				}
			},
			goGuest(selector, index) {
			    this.activeBtn = index;
			    this.$el.querySelector(selector).scrollIntoView()
			},
			async InitMeetingInfo() {
				let params = {
					m: this.$route.query.m,
				};
				let res = await IMeetingInfo.InitMeetingInfo(params);
				if (res.Code === 1000) {
					this.enShow = res.whetchinen == 0 ? false : true
					this.introShow = res.isshowintrod == 0 ? true : false
					this.isshowprogram = res.isshowprogram
					if (this.enShow) {
						this.searchText = 'Please use name or institution to search for experts'
					} else {
						this.searchText = '请输入内容'
					}
					
					let parames = {
						m: this.m,
					};
					this.init();
				}
			},
			async init() {
			    try {
			        this.loading = true
			        const {
			            m,
			            dateid = this.dateid,
			            roomid = this.roomid,
			            search = this.searchWord,
			        } = this.$route.query //获得路由的参数
			        this.m = m
			
			        const _params = {
			            m: this.m
			        }
			        const res = await this.$http.schedule.GetAPIProDateRoom(_params)
					
					this.dateDatas = res.childens;
					if( this.enShow ){
						for (let i in this.dateDatas) {
							if (this.dateDatas[i].name == '全部日期') {
								this.dateDatas[i].name = 'All Dates'
							}
							if(this.dateDatas[i].name.indexOf('月')!=-1){
								this.dateDatas[i].name = this.dateDatas[i].name.replace('月','.')
							}
							if(this.dateDatas[i].name.indexOf('日')!=-1){
								this.dateDatas[i].name = this.dateDatas[i].name.replace('日',' ')
							}
						}
					}
					
					for( let i in this.dateDatas ){
						if( this.dateDatas[i].child.length > 0 ){
							this.dateDatas[i].child.shift()
						}
					}
					
			        this.guestList(this.roomid)
			
			        this.loading = false
			    } catch (error) {
			        console.error(error)
			    }
			
			    // this.$toast.clear(false); //关闭加载动画
			},
			
			async guestList(){
			    try {
			        const {
			            m,
			            search = this.searchWord,
						rid = this.rid,
			        } = this.$route.query //获得路由的参数
			        this.m = m
			        const _params = {
						m: this.m,
						roomid: this.roomid,
						search: this.searchWord
					}
			        const res = await this.$http.schedule.GetAPIExpertProList(_params)
			        console.log(res)
			        this.expertList = res.ExpertList
			        this.pinYinList = res.PinYinList

			        if (this.pinYinList.includes('#') && (!this.expertList['#'] || this.expertList['#'].length === 0)) {
			            this.pinYinList = this.pinYinList.filter(item => item !== '#')
			        }
			    } catch (error) {
			        console.error(error)
			    }
			},
			/**
			 * 选择日期
			 */
			handleMeetingDate(i, data) {
				this.dateIndex = i;
				if( i == 0 ){
					this.roomid = 0
					this.guestList();
				}else{
					if( data.child && data.child.length > 0 ){
						this.roomid = data.child[0].value
						this.guestList();
					}else{
						this.roomid = 0
						this.guestList();
					}
				}	
			},
			goSchedules() {
				this.dateIndex = 0
				this.searchWord = ''
				this.roomid = 0
				this.guestList();
			},
			/**
			 * @des 搜索
			 */
			handleSearch() {
				this.guestList(this.roomid);
			},
			/**
			 * @des 嘉宾个人信息
			 */
			async handleExname(exid) {
				let parames = {
					m: this.m,
					exid,
				};
				let res = await this.$http.schedule.GetAPIExpertProgram(parames);
				let _list = [];
				this.showExList = true;
				let {
					photo,
					cnintroduction,
					cncompany,
					cnname,
					enintroduction,
					enname,
					encmpany
				} = res.expert;
				this.exPhoto = photo;
				console.log(res.expert)

				this.cnintroduction = cnintroduction;
				this.excnname = cnname;
				this.cncompany = cncompany;
				if (cnintroduction) {
					this.cnintroduction = cnintroduction.replace(/\n/g, "<br>");
				}

				this.enname = enname;
				this.encompany = encmpany;
				this.enintroduction = enintroduction;
				if (enintroduction) {
					this.enintroduction = enintroduction.replace(/\n/g, "<br>");
				}


				res.DateListEntity.map((item, index) => {
					let _k = [];
					for (let i in item.programListEntity) {
						let _D = item.programListEntity[i];
						let {
							programList
						} = _D.programs;
						for (let j in programList) {
							let _S = programList[j];
							programList[j] = {
								//时间和日期
								proDate: item.proDate,
								createdTime: this.formatDate(_S.programDate.prodate),
								startTime: _S.starttime,
								endTime: _S.endtime,
								pohto: res.expert.photo, //头像路径
								topic: _S.topic,
								entopic: _S.entopic,
								roomName: _S.programRoom.roomname,
								roomTitle: _S.programRoom.roomtitle,
								roomEnName: _S.programRoom.roomenname,
								roomEnTitle: _S.programRoom.roomentitle,
								roleName: _S.expertList[0].exrolemodel.rolename,
								ProgramCount: item.ProgramCount, //总数量
							};
							_k.push(programList[j]);
						}
					}

					_list.push(_k);
				});

				this.exDatas = _list;
				console.log(this.exDatas)
			},
			formatTime(val) {
				let et = val.split("(");
				let end = et[1].split(")")[0];
				let endtime = Number(end);
				let date = new Date(endtime);
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				return h + ":" + m;
			},
			formatDate(val) {
				let et = val.split("(");
				let end = et[1].split(")")[0];
				let date = new Date(Number(end));
				let month = date.getMonth() + 1;
				let day = date.getDate();
				return month + "-" + day;
			},
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			/**
			 * 所有详细日程数据（DateListEntity）
			 */
			async searchChData(parames) {
				this.isLoading = true;
				let _d = [],
					_da = [];
				let _res = await this.$http.schedule.GetAPIProgram(parames);

				if (_res.Code === 1000) {
					if (_res.DateListEntity.length) {
						_res.DateListEntity.map((items) => {
							let item = items.programListEntity;
							for (let i in item) {
								let _i = item[i].programs.programList;
								for (let j in _i) {
									let _j = _i[j];
									let {
										starttime,
										endtime,
										upproid,
										expertList,
										programDate
									} = _j;
									let {
										month,
										day
									} = this.current.changeFormDate(programDate.prodate);
									_j.starttime = starttime;
									_j.endtime = endtime;
									_j.programDate.prodate = month + "月" + day + "日";
									_j.ssl_identityList = this.filterRolename(expertList);
									items.programListEntity[i].programs.programList[j] = _j;
								}
								_d = items.programListEntity[i].programs.programList;
								console.log(_d)
								/**_d = this.dealData(0, _i);*/

								if (_d.length > 0) {
									_d.unshift({
										roomname: _d[0].programRoom.roomname,
										ssl_roomtitle: _d[0].programRoom.roomtitle,
										id: "ssl_" + _d[0].proid,
										prodate: _d[0].programDate.prodate,
									});
									_da.push(_d);
								}

							}
						});
						this.searchDatas = _da;
						this.searchDatas.forEach(item => {
							if (this.enShow) {
								if (item[0].prodate.indexOf('月') != -1) {
									item[0].prodate = item[0].prodate.replace('月', '.')
								}
								if (item[0].prodate.indexOf('日') != -1) {
									item[0].prodate = item[0].prodate.replace('日', ' ')
								}
							}
						})
					} else {
						this.$message.error({
							message: "未搜索到",
							customClass: "errorMessage"
						});
					}
				}
				this.isLoading = false;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(
					`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件`,
				);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			nToBr(str){
				if( str ){
					return str.replace(/\\n/g,'<br/>');
				}else{
					return str
				}
			},
		}
	}
</script>
<style>
	.el-table thead {
		background-color: #3b82f6;
		color: #fff;
	}

	.el-table th.el-table__cell.is-leaf,
	.el-table th {
		background-color: #3b82f6;
		padding: 5px 0;
	}

	.el-table td,
	.el-table th {
		padding: 5px 0;
	}

	.el-table__body,
	tbody,
	.el-table__row {
		width: auto !important;
	}

	.topic_tit {
		margin-bottom: 10px;
		height: 100%;
		overflow-y: scroll;
	}

	.search {
		button {
			margin-left: 8px;
		}
	}

	.room_tit {
		>span {
			margin-right: 10px;
		}
	}
</style>

<style scoped lang="scss">
	#schedule {
		color: #333;
		font-size: 14px;
		background: #f8fafc;
		width: 100%;

		.schedule_container {
			width: 100%;
			margin: 0 auto;
			background: #fff;

			.position {
				padding: 0 10px;
				background: #fafafa;
				border-bottom: 1px solid #ddd;
				line-height: 40px;
				border-top: 1px solid #ddd;
				font-size: 14px;
				color: #777;

				a {
					color: #3b82f6;
					cursor: pointer;
				}
			}

			.filter {
				padding: 10px 15px 0;
				display: flex;
				font-size: 14px;
				line-height: 30px;

				.filter-label {
					width: 80px;
				}

				.filter-wrap {
					flex: 1;

					.meetingDate {
						display: flex;
						flex: 1;

						>li {
							padding: 0 5px;
							margin-right: 10px;

							&:hover {
								cursor: pointer;
							}
						}
					}
				}
			}

			.table_con {
				min-height: 600px;
				
				.guest-con {
				    position: relative;
				}
				.guestlist {
					
					.expert-nav{
						height: 34px;
						line-height: 34px;
						padding: 0px 10px;
						background: #f7f4f8;
						font-weight: bold;
						font-size: 18px;
					}
				    .guest-list {
				        background: #fff;
						padding: 10px 40px 10px 20px;
				        margin-top: 0;
				        border-bottom: 1px solid #d8d6d9;
				        display: flex;
						cursor: pointer;
				        .guest-photo {
				            width: 80px;
				            margin-right: 20px;
				
				            img {
				                width: 80px;
				                height: 80px;
				                border-radius: 50%;
				            }
				        }
				
				        .guest-info {
				            flex: 1;
				
				            .guest-cname {
				                font-size: 16px;
				            }
				
				            .guest-cncompany {
				                font-size: 12px;
				                color: #666;
								margin-top: 5px;
				            }
				
				            .guest-cnintroduction {
				                position: relative;
				                font-size: 12px;
				                line-height: 20px;
								margin-top: 5px;
				                color: #999;
				                display: -webkit-box;
				                overflow: hidden;
				                text-overflow: ellipsis;
				                -webkit-box-orient: vertical;
				                -webkit-line-clamp: 2;
								word-break: break-all;
				                span {
				                    position: absolute;
				                    right: 0;
				                    bottom: 0;
				                    background: #fff;
				                    z-index: 2;
				                    color: #00439a;
				                    box-shadow: -1px 0 2px #fff;
				                    display: block;
				                }
				            }
				        }
				    }
				}
				
				.guest-nav-fixed {
				    position: fixed;
				    left: 0;
				    right: 0;
				    top: 0;
				    height: 60px;
				    z-index: 100;
				    background: #f0f0f0;
				}
				
				.guset-nav {
				    position: absolute;
				    top: 34px;
				    right: 0;
				    width: 30px;
				    height: 100%;
				    z-index: 100;
				    background: #f0f0f0;
				    color: #333;
				    opacity: 0.8;
				
				    .letter-t {
				        font-size: 16px;
				        line-height: 30px;
				        text-align: center;
						cursor: pointer;
				    }
				
				    .weight {
				        font-weight: 800;
				    }
				}
				
				.fixed {
				    position: fixed;
					right: 0;
					top: 0;
				}

				.meeting-table {
					margin-bottom: 20px;
				}

				.meeting-prodate {
					text-align: center;
					font-size: 26px;
					color: #3b82f6;
					margin-bottom: 8px;
					padding-bottom: 8px;
					border-bottom: 1px solid #ddd;
				}

				.meeting-roomname {
					font-size: 18px;
					font-weight: bold;
					color: #666;
					margin-bottom: 10px;
				}

				.meeting-first {
					width: 100%;
				}

				.meeting-1 {
					padding: 12px 0;
					border-bottom: 1px dotted #ccc;
				}

				.meetingBorder {
					border-bottom: none
				}

				.meeting-2 {}

				.meeting-title {
					font-size: 14px;
					color: #666;
					font-weight: bold;

					img {
						width: 20px;
						height: 20px;
						vertical-align: -4px;
						margin-right: 5px;
					}
				}

				.meeting-guest {
					margin-top: 5px;
					display: flex;

					img {
						width: 20px;
						height: 20px;
						vertical-align: -4px;
						margin-right: 5px;
					}
				}

				.meeting-guest-span {
					flex: 1;
					margin-right: 10px;
					display: flex;

					.guest-list {
						flex: 1;
						margin-left: 10px;
					}
				}

			}

			.schedule_table {
				width: 100%;
				margin: 20px auto;
			}

			.schedule_nav {
				width: 100%;
				height: 57px;
			}

			.schedule_container_nav {
				min-height: 57px;
				background: #fff;
				display: flex;
				justify-content: space-between;
			}
		}

		.selected {
			background: #449bf5 !important;
			color: #fff;
			border-radius: 5px;
		}

		.selectedM {
			color: #278dfa;
		}

		.search {
			width: 450px;
			display: flex;
		}

		.exname {
			margin-right: 6px;
			margin-bottom: 5px;

			&:hover {
				cursor: pointer;
			}

			i {
				color: #278dfa;
				font-weight: bold;
			}
		}

		.ch_ex {
			display: flex;
			flex-wrap: wrap;
		}

		.details-head {
			border: 1px solid #dcdfe6;
			display: flex;
			padding: 10px 14px;
			margin-bottom: 15px;
			position: relative;

			.guest-headimg {
				text-align: center;
				margin-right: 10px;
				width: 80px;
				height: 80px;
				border-radius: 100px;

				img {
					width: 100%;
					height: 100%;
					border-radius: 160px;
					object-fit: cover;
				}
			}

			.guest-intro {
				margin: 10px 0;
				font-size: 14px;
				flex: 1;

				.host,
				.guest-name {
					margin-top: 8px;
				}
			}

			.uploadFile {
				position: absolute;
				right: 10px;
				top: 31%;
			}
		}

		.ex_details {
			max-height: 500px;
			overflow: auto;
		}

		.details-texts {
			display: flex;
			align-items: baseline;

			i {
				margin-right: 5px;
			}

			.details-text {
				flex: 1;
			}
		}

		.details-main {
			margin: 2px;
			margin-bottom: 10px;
			box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

			.details-main-head {
				border-bottom: 1px solid #ccc;
				padding: 8px 0;
				display: flex;
				justify-content: space-between;

				.details-main-head-date {
					color: #0e0ea5;
					padding: 0 0 0 10px;

					>i {
						margin-right: 4px;
					}
				}

				.details-list-num {
					min-width: 20px;
					height: 20px;
					margin-right: 10px;
					background: #00439a;
					border-radius: 6px;
					color: #fff;
					text-align: center;
					line-height: 20px;
				}
			}

			.details-main-con {
				padding: 10px 0;
				border-bottom: 1px solid #ccc;
				margin: 0 10px;

				>div {
					margin: 6px 0;
				}

				&:last-child {
					border: 0;
				}
			}
		}

		.guestIntroduction {
			line-height: 26px;
			min-height: 143px;
			margin: 10px 2px;
			padding: 10px;
			box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
		}

		.roomList {

			.meetingName,
			.meetingDate {
				display: flex;
				line-height: 23px;
				font-size: 14px;
			}

			.meetingName {
				flex-wrap: wrap;

				>li {
					padding: 10px;
					margin: 6px 10px;
					border: 1px solid #ebeef5;
					border-radius: 10px;

					&:hover {
						cursor: pointer;
					}
				}
			}
		}

		.fixed_tit {
			width: 70%;
			background: #fff;
		}

		.personalCenter_content_subheading {
			margin-left: 40px;
			height: 40px;
			display: flex;
			justify-content: space-between;
		}
	}

	.is_fixed {
		position: fixed;
		top: 0;
		z-index: 9;
	}
</style>
